const RETAX_ACTIONS = 'retax:actions';

export const METADATA_KEYS = { RETAX_ACTIONS };
